/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Header from "./common/header";
import Footer from "./common/footer-new";
import { Location } from '@reach/router';
import CookieConsent , {getCookieConsentValue} from 'react-cookie-consent';
import { Link } from "gatsby";
//import { animateScroll } from 'react-scroll';

const Layout = ({ children, addBodyClass, verticleNav, footerData, footerType = "basic" }) => {
  const text = footerData ? footerData : { footerText: "", oneLine: false };
  //const scroll = animateScroll;

  /* useEffect(()=>{
    scroll.scrollMore(300);
    setTimeout(()=>{
      scroll.scrollMore(-300);
    },1800)
  },[]); */

  return (
    <>
      <Location>
        {({ location }) =>
          <>
            <Header location={location} addBodyClass={addBodyClass} verticleNav={verticleNav} />
            <div className="site-body">
              <main>{children}</main>
            </div>
            <div className="cookie-consent-wrapper">
              <div className="container">
                <CookieConsent
                  style={{textAlign:"center"}}
                  location="bottom"
                  buttonText="I understand"
                  declineButtonText="Decline"
                  cookieName="gatsby-gdpr-google-analytics"
                  enableDeclineButton
                  >
                  We use cookies to make our websites secure, functional, and accessible to understand how visitors interact with our website, to improve user experience, and present users with the personalized content. For more detailed information and to manage your preferences later, please see our <Link to="/privacy-policy/">Cookies Policy.</Link>
                </CookieConsent>
              </div>
            </div>
            <Footer location={location} footerData={text} footerType={footerType} />
          </>
        }
      </Location>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
